export enum TablesGridDataKey {
  NAME = 'NAME',
  SELECT = 'SELECT',
  TYPE = 'TYPE',
  EXTRACT = 'EXTRACT',
  POLICIES = 'POLICIES',
  DATABASE = 'DATABASE',
  SCHEMA = 'SCHEMA'
}
